import * as types from '../API/ActionTypes';
import InitialState from './initialState';

export function addTicketCommentErrorReducer(state = InitialState.addTicketCommentErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ADD_TICKET_COMMENT_ERROR:
			return action.addTicketCommentErrorFlag;
		default:
			return state;
	}
}

export function addTicketCommentLoadingReducer(state = InitialState.addTicketCommentLoading, action) 
{
	switch (action.type) 
	{
		case types.ADD_TICKET_COMMENT_LOADING:
			return action.addTicketCommentLoading;
		default:
			return state;
	}
}

export function addTicketFeedbackErrorReducer(state = InitialState.addTicketFeedbackErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ADD_TICKET_FEEDBACK_ERROR:
			return action.addTicketFeedbackErrorFlag;
		default:
			return state;
	}
}

export function addTicketFeedbackLoadingReducer(state = InitialState.addTicketFeedbackLoading, action) 
{
	switch (action.type) 
	{
		case types.ADD_TICKET_FEEDBACK_LOADING:
			return action.addTicketFeedbackLoading;
		default:
			return state;
	}
}

export function addTicketFeedbackReducer(state = InitialState.ticketFeedback, action) 
{
	switch (action.type) 
	{
		case types.ADD_TICKET_FEEDBACK:
			return action.ticketFeedback;
		default:
			return state;
	}
}

export function assignUserToTicketErrorReducer(state = InitialState.assignUserToTicketErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ASSIGN_USER_TO_TICKET_ERROR:
			return action.assignUserToTicketErrorFlag;
		default:
			return state;
	}
}

export function assignUserToTicketLoadingReducer(state = InitialState.assignUserToTicketLoading, action) 
{
	switch (action.type) 
	{
		case types.ASSIGN_USER_TO_TICKET_LOADING:
			return action.assignUserToTicketLoading;
		default:
			return state;
	}
}

export function createTicketByUserFeedOrAssetFeedReducer(state = InitialState.ticketCreatedStatus, action) 
{
	switch (action.type) 
	{
		case types.CREATE_TICKET_STATUS:
			return action.ticketCreatedStatus;
		default:
			return state;
	}
}

export function createTicketByUserFeedOrAssetFeedErrorReducer(state = InitialState.createTicketErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.CREATE_TICKET_ERROR:
			return action.createTicketErrorFlag;
		default:
			return state;
	}
}

export function createTicketByUserFeedOrAssetFeedLoadingReducer(state = InitialState.createTicketLoading, action) 
{
	switch (action.type) 
	{
		case types.CREATE_TICKET_LOADING:
			return action.createTicketLoading;
		default:
			return state;
	}
}
export function feedbackHistoryErrorReducer(state = InitialState.feedbackHistoryErrorFlag, action)
{
	switch (action.type)
	{
		case types.FEEDBACK_HISTORY_ERROR:
			return action.feedbackHistoryErrorFlag;
		default:
			return state;
	}
}

export function feedbackHistoryLoadingReducer(state = InitialState.feedbackHistoryLoading, action)
{
	switch (action.type)
	{
		case types.FEEDBACK_HISTORY_LOADING:
			return action.feedbackHistoryLoading;
		default:
			return state;
	}
}

export function feedbackHistoryReducer(state = InitialState.feedbackHistory, action)
{
	switch (action.type)
	{
		case types.FEEDBACK_HISTORY:
			return action.feedbackHistory;
		case types.ADD_TICKET_FEEDBACK_HISTORY:
			return state.concat(action.ticketFeedback);
		default:
			return state;
	}
}

export function ticketCloseOrReopenErrorReducer(state = InitialState.ticketCloseOrReopenErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.TICKET_CLOSE_OR_REOPEN_ERROR:
			return action.ticketCloseOrReopenErrorFlag;
		default:
			return state;
	}
}

export function ticketCloseOrReopenLoadingReducer(state = InitialState.ticketCloseOrReopenLoading, action) 
{
	switch (action.type) 
	{
		case types.TICKET_CLOSE_OR_REOPEN_LOADING:
			return action.ticketCloseOrReopenLoading;
		default:
			return state;
	}
}

export function ticketCloseOrReopenReducer(state = InitialState.ticketCloseOrReopenData, action) 
{
	switch (action.type) 
	{
		case types.TICKET_CLOSE_OR_REOPEN:
			return action.ticketCloseOrReopenData;
		default:
			return state;
	}
}

export function ticketDetailsErrorReducer(state = InitialState.ticketDetailsErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.TICKET_DETAILS_ERROR:
			return action.ticketDetailsErrorFlag;
		default:
			return state;
	}
}

export function ticketDetailsLoadingReducer(state = InitialState.ticketDetailsLoading, action) 
{
	switch (action.type)
	{
		case types.TICKET_DETAILS_LOADING:
			return action.ticketDetailsLoading;
		default:
			return state;
	}
}

export function ticketDetailsReducer(state = InitialState.ticketDetails, action) 
{
	switch (action.type) 
	{
		case types.TICKET_DETAILS:
			return Object.assign({}, state, action.ticketDetails);
		case types.ASSIGN_USER_TO_TICKET:
			return {
				...state,
				ticketAssignedTo: action.ticketDetails.ticketAssignedTo,
				ticketAssignedToId: action.ticketDetails.ticketAssignedToId
			}
		default:
			return state;
	}
}

export function feedbackFileReducer(state = {
	feedbackFiles: [],
	feedbackFilesLoading: false,
	feedbackFilesError: false
}, action) {
	switch (action.type) {
		case types.FEEDBACK_FILES_BY_TICKET_ID:
			return { ...state, feedbackFiles: action.feedbackFiles };

		case types.FEEDBACK_FILES_BY_TICKET_ID_LOADING:
			return { ...state, feedbackFilesLoading: action.loadingFlag };

		case types.FEEDBACK_FILES_BY_TICKET_ID_ERROR:
			return { ...state, feedbackFilesError: action.errorFlag };

		case types.CLEAR_FEEDBACK_FILES:
			return { ...state, feedbackFiles: [] };

		default:
			return state;
	}
}
